import PropTypes from 'prop-types';
import React from 'react';

import padStart from 'lodash/padStart';

import StripeRedirectModal from 'components/StripeRedirectModal';
import Button from 'components/buttons/Button';
import cardIcons from 'constants/cardIcons';
import stripePortalConfigNames from 'constants/stripePortalConfigNames';
import useRedirectToStripePortal from 'hooks/useRedirectToStripePortal';
import { useTracking } from 'modules/segment/TrackingProvider';
import GenericCardIcon from 'static/cardBrands/GenericCardIcon';

const BillingSettingsPaymentDetails = ({
  expiryMonth = 0,
  expiryYear = 0,
  lastDigits = '',
  brand = '',
}) => {
  const trackingService = useTracking();
  const CardIcon = cardIcons[brand] || GenericCardIcon;
  const { isRedirecting, redirectToStripePortal } = useRedirectToStripePortal(
    stripePortalConfigNames.PAYMENT_UPDATE
  );

  const updatePaymentDetails = async (event) => {
    await trackingService.track('subscription_update', {
      action: 'paymentDetails_update',
    });
    redirectToStripePortal(event);
  };

  return (
    <div className="flex flex-col h-full">
      <div className="flex flex-row gap-2 mb-4">
        <CardIcon className="w-[1.95rem] h-5 shrink-0 mt-1" />
        <div>
          <p>Ending with {lastDigits}</p>
          <p className="text-gray-500">
            Expires {padStart(expiryMonth, 2, '0')} / {expiryYear}
          </p>
        </div>
      </div>
      <Button
        type="secondary"
        className="w-fit mt-auto"
        onClick={updatePaymentDetails}
      >
        Update payment details
      </Button>
      <StripeRedirectModal isRedirecting={isRedirecting} />
    </div>
  );
};

BillingSettingsPaymentDetails.propTypes = {
  expiryMonth: PropTypes.number,
  expiryYear: PropTypes.number,
  lastDigits: PropTypes.string,
  brand: PropTypes.string,
};

export default BillingSettingsPaymentDetails;
